// src/api/index.js
import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000',
  headers: { 'Content-Type': 'application/json' },
});

/**
 * Call once after login (or on app start if token exists)
 */
export const setAuthToken = (token) => {
  if (token) {
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  } else {
    delete api.defaults.headers.common['Authorization'];
  }
};

/* Keep token in sync on every page load */
if (typeof window !== 'undefined') {
  const saved = localStorage.getItem('token');
  if (saved) setAuthToken(saved);
}

/* 401 → auto-logout */
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('token');
      setAuthToken(null);
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default api;